import {VetineoVisitTypeBundle} from "./vetineo-visit-type-bundle.model";

/**
 * Model reprezentujący pojedynczy benefit (pozycję) wewnątrz szablonu abonamentu (Wellness Plan).
 * Działa jako reguła przydziału – łączy konkretną usługę medyczną
 * z limitami narzuconymi przez wykupiony pakiet (częstotliwość i ilość).
 */
export class WellnessPlanItem {

  /** Globalnie unikalny identyfikator. */
  public uuid: string;

  /** Referencja do szablonu głównego planu (WellnessPlan), do którego należy ten element. */
  public wellnessPlanUUID: string;

  /** Identyfikator administratora/pracownika, który dodał tę pozycję do planu. */
  public authorUUID: string;
  public created: Date;

  /** Data usunięcia.
   */
  public deleted: Date;

  /** Nazwa wyświetlana dla tego konkretnego benefitu.
   */
  public name: string;

  /** Liczba dostępnych użyć (Allowance Quantity).
   * Określa, ile razy pacjent może skorzystać z tego benefitu
   * (np. 1 raz, 4 razy) w danym oknie czasowym.
   */
  public quantity: number;

  /** Częstotliwość odnawiania limitu.
   * Razem z `quantity` tworzy pełną regułę biznesową: "2 razy w roku" lub "1 raz w miesiącu".
   */
  public wellnessPlanItemFrequency: string;

  /** Dodatkowy parametr czasowy.
   */
  public time: number;

  /** Kolejność wyświetlania tego benefitu na liście w aplikacji pacjenta.
   * Pozwala wypromować najważniejsze usługi na samą górę.
   */
  public orderIndex: number;

  /** Identyfikator powiązanej usługi.
   */
  public vetineoVisitTypeBundleUUID: string;
  /** Powiązana usługa. */
  public vetineoVisitTypeBundle: VetineoVisitTypeBundle;

  /** Identyfikator powiązanego obiektu `CarePlanService`.
   */
  public carePlanServiceUUID: string;

  /** Identyfikator grupy usługi. Służy do kategoryzacji benefitów
   */
  public typeUUID: string;

}
